module.exports = __webpack_public_path__ + "static/media/icomoon.845c1293.woff";